<!--@description 封装全局底部弹窗
    @author cc
    @date 2020-3-12
  -->
<template>
  <div ref="elPopup">
    <div class="xpt-popup" :class="{ 'xpt-popup__open' : isShowPopup, 'xpt-popup__close': !isShowPopup }" :style="{'height':elHeight}">
       <cc-svg-icon
        size=".21rem"
        @click="close"
        class-name="xpt-close"
        icon-class="cancel-new"
        color="#dbdbdb"
      ></cc-svg-icon>
      <!-- 购物车的头部-->
      <div class="popup-cart-header" v-if="$slots.header">
        <slot name="header"></slot>
      </div>
      <!-- 普通的头部 -->
      <div v-else class="popup-header">{{title}}</div>
      <!-- 内容部分 -->
      <div class="center">
        <slot ></slot>
      </div>
      <!-- 底部按键 -->
      <div class="con-bottom" v-if="showBtn">
          <a v-if="region" class="subBtn" style="background:#BFBFBF">{{subText}}</a>
          <a v-else class="subBtn" @click="subBtn()">{{subText}}</a>
        </div>
      </div>
    <div v-if="isShowPopup" @click="close" class="xpt-modal"></div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Field, Checkbox } from 'vant'
import { judgeDeviceType } from '../../../utils'
Vue.use(Field).use(Checkbox)
function getElement (selector) {
  if (typeof selector === 'string') {
    return document.querySelector(selector)
  }

  return selector()
}
const originHeight = document.documentElement.clientHeight || document.body.clientHeight

export default {
  name: 'CcBottomPopup',
  props: {
    subText: {
      type: String,
      default: '确定'
    },
    title: {
      type: String,
      default: ''
    },
    isShowPopup: {
      type: Boolean,
      default: false
    },
    // 像购物车头部的高度自定义
    HeaderHight: {
      type: Number,
      default: 0
    },
    // 高度
    height: {
      type: [Number, String],
      default: 0
    },
    // 底部确定按键是否显示
    showBtn: {
      type: Boolean,
      default: true
    },
    // 挂载的节点
    getContainer: {
      type: String
    },
    position: {
      type: Boolean,
      default: true
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    region: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      elHeight: this.transformUnit(this.height)
    }
  },
  mounted () {
    if (this.getContainer) {
      this.portal()
    }
    if (this.autoHeight) {
      this.listenKeybord()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.bindHandler)
    if (this.getContainer && this.$parent && this.$parent.$el) {
      this.$parent.$el.appendChild(this.$el)
    }
  },
  methods: {
    transformUnit (data) {
      return isNaN(data) ? data : data / 100 + 'rem'
    },
    bindHandler () {
      let resizeHeight = document.documentElement.clientHeight || document.body.clientHeight
      if (originHeight <= resizeHeight) {
        this.elHeight = this.transformUnit(this.height)
        // Android 键盘收起后操作
      } else {
        this.elHeight = resizeHeight + 'px'
        // Android 键盘弹起后操作
      }
    },
    listenKeybord () {
      // Andriod 键盘收起：Andriod 键盘弹起或收起页面高度会发生变化，以此为依据获知键盘收起
      if (judgeDeviceType.isAndroid) {
        window.addEventListener('resize', this.bindHandler, false)
      }
    },
    close: function () {
      // this.$emit('input', !this.isShowPopup)
      this.$emit('close')
    },
    // 确定按键
    subBtn () {
      this.$emit('subBtn')
    },
    portal () {
      const { getContainer } = this
      const el = this.$el
      let container
      if (getContainer) {
        container = getElement(getContainer)
      } else if (this.$parent) {
        container = this.$parent.$el
      }
      if (container && container !== el.parentNode) {
        container.appendChild(el)
      }
    }
  },
  watch: {
    isShowPopup (value) {
      if (!value) {
        this.$emit('closeCallback')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.xpt-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  z-index: 1000;
}
.center{
  flex: 1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.popup-cart-header{
  width: 100%;
  border-bottom: 1px solid #f2f2f2;
  box-sizing: border-box;
  padding: 10px 0 0 10px;
  display: flex;
}
.popup-header{
  height: 45px;
  width: 100%;
  @include center();
  @include sc(15px,#333333);
  font-weight: bold;
  box-sizing: border-box;
  border-bottom: 1px solid #f2f2f2;
}
.xpt-popup {
  position: fixed;
  // position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 1001;
  // border-top: 1px solid #f5f5f5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: 0.3s all ease-in;
  transition: 0.3s all ease-in;
  border-radius: 8px 8px 0 0;
  display: flex;
  flex-direction: column;
}
.xpt-popup__close {
  -webkit-transform: translate3d(0, 150%, 0);
  transform: translate3d(0, 150%, 0);
}
.xpt-popup__open {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.xpt-close {
  position: absolute;
  top: 10px;
  right:10px;
  font-size: 24px !important;
}
// ============
.nogoods-con {
  // height: 100%;
  // height: 377px;
  flex: 1;
  &-header{
    height: 45px;
    width: 100%;
    @include center();
    @include sc(15px,#333333);
    font-weight: bold;
    box-sizing: border-box;
    border-bottom: 1px solid #f2f2f2;
  }
}
.con-bottom{
    height: 50px;
    @include center();
    border-top: 1px solid #f2f2f2;
  .subBtn {
    @include wh(355px,35px);
    @include center();
    @include sc(14px,#fff);
    border-radius: 20px;
    background: var(--APP_theme_color);
    }
}
</style>
